import React from 'react'
import { Form, Row, Col, Input, Button, Typography, message, Space } from 'antd'
import { withRouter } from 'react-router'
import { reqResetPwdEmail, reqCaptcha } from '../../api'

const { Title } = Typography

class ForgetPwd extends React.Component {
    state = {
        captcha_key: '',
        captcha_image: ''
    }

    onFinish = async (values) => {
        const result =await reqResetPwdEmail(values.email)
        if (result.code === 0) {
            message.success('Request success! Please check the email for password reset.')
            this.props.history.push('/success/resetPwdEmail')
        } else {
            message.error('Request failed!')
        }
    }

    getCaptcha = async () => {
        const captcha_result = await reqCaptcha()
        if (captcha_result.code === 0) {
            const captcha_image = <img src={`data:image/png;base64,${captcha_result.data.captcha_image}`} />
            this.setState({
                captcha_key: captcha_result.data.captcha_key,
                captcha_image: captcha_image
            })
        } else {
            message.error('Get captcha failed.')
        }
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 14,
            },
        }
        
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 14,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        }

        return (
            <React.Fragment>
                <Row justify="center">
                    <Col>
                        <Title level={3}>Request Password</Title>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={14}>
                        <Form {...formItemLayout} name="request_passwd" onFinish={this.onFinish} validateTrigger='onSubmit'>
                            <Form.Item name="email" label="E-mail"
                                rules={[
                                {
                                    type: 'email',
                                    message: 'The input is not valid E-mail!',
                                },
                                {
                                    required: true,
                                    message: 'Please input your E-mail!',
                                },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item label="Captcha">
                                <Row gutter={8}>
                                    <Col span={10}>
                                        <Form.Item
                                            name="captcha"
                                            noStyle
                                            rules={[{ required: true, message: 'Please input the captcha you got!' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Space>
                                            <Button onClick={this.getCaptcha}>Get captcha</Button>
                                            {this.state.captcha_image}
                                        </Space>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item {...tailFormItemLayout}>
                                <Button type="primary" htmlType="submit" className="request-passwd-button" block>Submit</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default withRouter(ForgetPwd)